
Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.CardFieldViewer = function (config) {

    Greenmile.PanelBuilder.CardField.apply(this, arguments);

    var attributeClasses = 'description';

    this.container = document.createElement("div");
    this.container.setAttribute('class', "CardDescription");

    this.el = document.createElement("div");
    this.el.setAttribute('class', attributeClasses);

    this.container.appendChild(this.el);

    this.updateWhenHasField = function () {
        var columns = [{
            entity: "RouteView",
            field: this.field.name,
            fieldInformation: this.field
        }];

        var fieldKey = "";

        var collection = new App.Collections.RouteViews([this.routeView]);

        var json = Monet.Grid.formatDataFromCollection(columns, collection, "RouteView")[0];

        var value = json[this.field.name];

        if (this.field.type !== "LOOKUP" && this.field.type !== "PICKLIST_MULTISELECT" && "TAG" !== this.field.type) {
            //field values which are 'true' or 'false' need to use their own respective resources
            if (this.field.name === "route.lastStopIsDestination") {
                value = (json[this.field.name]) ? `${Monet.I18n.getResourcesByKey('panelBuilder.lastStopIsDestination')}` : `${Monet.I18n.getResourcesByKey('panelBuilder.lastStopIsNotDestination')}`;
            } else if (this.field.name === "route.hasGps") {
                value = (json[this.field.name]) ? `${Monet.I18n.getResourcesByKey('panelBuilder.hasGps')}` : `${Monet.I18n.getResourcesByKey('panelBuilder.noGps')}`;
            } else if (this.field.name === "route.hasHelper") {
                value = (json[this.field.name]) ? `${Monet.I18n.getResourcesByKey('panelBuilder.hasHelper')}` : `${Monet.I18n.getResourcesByKey('panelBuilder.noHelper')}`;
            } else {
                value = Monet.FormBuilder.FormatterGridColumn(0, 1, json[this.field.name], columns[0], json);
            }
        } else {
            fieldKey = this.field.lookupEntityColumn;
        }

        if (typeof value === "string" || typeof value === "number") {

            if (this.field.name === "route.status") {
                value = Monet.Grid.Utils.getStatusRoute(value);
            }

            if (this.field.name === "route.hasPicture") {
                this.el.title = Monet.I18n.getResourcesByKey("route.hasPicture");
            } else {
                this.el.title = value;
            }

            this.el.innerHTML = value;

        } else if (typeof value === "object") {
            this.el.innerHTML = value.name || value.description || value[fieldKey];
            this.el.title = value.name || value.description || value[fieldKey];
        }
    };

    this.updateWhenHasAttribute = function () {
        var value = this.attribute.split(".").reduce(function (a, b) {
            if (!a || !a[b]) {
                return null;
            }
            return a[b];
        }, this.routeView);
        this.el.innerHTML = value;
        this.el.title = value;
    };


    this.update = function (cardField) {

        if (cardField) {

            if (cardField.field.getValue) {
                this.field = cardField.field.getValue();
            } else {
                this.field = cardField.field;
            }

        }

        if (this.field && this.routeView) {
            this.updateWhenHasField();
        } else if (this.routeView && this.attribute) {
            this.updateWhenHasAttribute();
        } else {
            this.el.title = "";
            this.el.innerHTML = "";
        }

    };

    this.render = function (className) {

        if (className) {
            this.el.setAttribute('class', attributeClasses + " " + className);
        }

        this.update();
        return this.container;
    };


};